import React, {ReactElement} from 'react';
import ReactDOM from 'react-dom';
import PuppyCard from "../card/puppy-card";
import Slider from "react-slick";
import {PuppyCardInterface} from "../../../structures/models/listings";

interface FeaturedPuppiesSliderProps {
  puppies: PuppyCardInterface[];
}

const FeaturedPuppiesSlider = ({puppies}: FeaturedPuppiesSliderProps): ReactElement => {
  const settings = {
    infinite: puppies.length >= 4,
    slidesToShow: 4,
    rows: 1,
    speed: 500,
    centerMode: puppies.length < 4,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    puppies.length > 0 ? (
      <Slider {...settings}>
        {puppies.map((puppy: any) => (
          <div key={puppy.id}>
            <div className="react-puppy-card">
              <PuppyCard puppydata={puppy} />
            </div>
          </div>
        ))}
      </Slider>
    ) : (
      <div className="text-center w-100 pa-3">
        <p>
          No featured puppies available
        </p>
      </div>
    )
  );
};

export default FeaturedPuppiesSlider;

if (document.getElementById('react-featured-puppies-slider')) {
  const element = document.getElementById('react-featured-puppies-slider');
  const puppiesAttr = element?.getAttribute('data-puppies');
  const puppies = puppiesAttr ? JSON.parse(puppiesAttr) : [];
  ReactDOM.render(<FeaturedPuppiesSlider puppies={puppies} />, element);
}
